import React, { useState, useCallback, useEffect } from 'react';
import { ErrorReportContext } from './ErrorReportContext';
import ErrorReportModal from './ErrorReportModal';
import { useFeatureFlags } from 'hooks/useFeatureFlags';
import {
  registerErrorModalCallback,
  unregisterErrorModalCallback,
} from 'Utils/DisplayErrorWithReport';

const ErrorReportProvider = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [errorDetails, setErrorDetails] = useState(null);
  const { enableErrorReportV2 } = useFeatureFlags();

  const showErrorModal = useCallback((details) => {
    setErrorDetails({
      message: details?.message || 'An error occurred',
      stackTrace: details?.stackTrace || null,
      endpoint: details?.endpoint || null,
      timestamp: details?.timestamp || new Date().toISOString(),
    });
    setShowModal(true);
  }, []);

  const hideErrorModal = useCallback(() => {
    setShowModal(false);
    setErrorDetails(null);
  }, []);

  // Register callback for displayErrorWithReport utility
  useEffect(() => {
    registerErrorModalCallback(showErrorModal, () => enableErrorReportV2);
    return () => {
      unregisterErrorModalCallback();
    };
  }, [showErrorModal, enableErrorReportV2]);

  return (
    <ErrorReportContext.Provider value={{ showErrorModal, hideErrorModal }}>
      {children}
      <ErrorReportModal
        show={showModal}
        onClose={hideErrorModal}
        errorDetails={errorDetails}
      />
    </ErrorReportContext.Provider>
  );
};

export default ErrorReportProvider;
